<template>
  <section class="project-section section-padding">
    <!-- Başlık -->
    <div class="sw-header">
      
      <h2 class="sw-title">{{vars.titleText}}</h2>
    </div>

    <!-- Filtre -->
    <ul class="sw-filter">
      <li :class="{active: filter==='all'}" @click="filter='all'">Show All</li>
      <li :class="{active: filter==='reel'}" @click="filter='reel'">Reels</li>
      <li :class="{active: filter==='post'}" @click="filter='post'">Posts</li>
    </ul>

   
    <div class="sw-grid">
      <div
        v-for="(item, i) in filteredList"
        :key="i"
        class="sw-item"
        @click="openPopup(item)"
      >
        
        <img
          v-if="item.media_type==='IMAGE'"
          :src="item.media_url"
          alt=""
        />
       
        <div v-else class="sw-video-thumb">
          <img :src="item.thumbnail_url" alt="" />
          <div class="sw-play"><svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z" fill="#fff"/></svg></div>
        </div>
      </div>
    </div>

   
    <popup
      v-if="selectedItem"
      :config="popupConfig"
      @close="popupConfig.isActive=false"
    >
      <template #content>
        <div class="sw-popup">
          <video
            v-if="selectedItem.media_type==='VIDEO'"
            :src="selectedItem.media_url"
            controls autoplay loop muted playsinline
          ></video>
          <img
            v-else
            :src="selectedItem.media_url"
            alt=""
          />
          <p class="sw-caption">{{ selectedItem.caption }}</p>
          <a :href="selectedItem.permalink" target="_blank">Go to Instagram ↗︎</a>
        </div>
      </template>
    </popup>
  </section>
</template>

<script lang="ts">
import Popup from '~/components/common/popup/Popup.vue'
import { ComponentMixin } from '~/mixins/component.mixin'

export default defineNuxtComponent({
  components: { Popup },
  mixins: [ComponentMixin],
  data() {
    return {
      instagram_posts: null as any,
      filter: 'all' as 'all'|'reel'|'post',
      selectedItem: null as any,
      popupConfig: { isActive: false }
    }
  },
  computed: {
    filteredList() {
      if(!this.instagram_posts) return []
      return this.instagram_posts.content_list.filter((p:any) => {
        if(p.is_deleted||p.is_hidden) return false
        if(this.filter==='all') return true
        if(this.filter==='reel' && p.media_type==='VIDEO') return true
        if(this.filter==='post' && p.media_type==='IMAGE') return true
        return false
      })
    }
  },
  methods: {
    openPopup(item:any){
      this.selectedItem = item
      this.popupConfig.isActive = true
    }
  },
  created(){
    this.instagram_posts = this.parseFormV2(this.vars.socialInstagramPosts)
  }
})
</script>

<style scoped>
.social-wall {
  max-width: 1200px;
  margin: auto;
  padding: 2rem 1rem;
}

/*— HEADER —*/
.sw-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
}
.sw-icon {
  width: 32px; height: 32px;
}
.sw-title {
  font-size: 2rem;
  margin: 0;
}

/*— FILTER —*/
.sw-filter {
  display: flex;
  justify-content: center;
  gap: 2rem;
  list-style: none;
  padding: 0;
  margin-bottom: 2rem;
  color: #888;
  font-size: 0.95rem;
}
.sw-filter li {
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s;
}
.sw-filter li:hover,
.sw-filter li.active {
  opacity: 1;
  color: #000;
}

/*— GRID —*/
.sw-grid {
  display: grid;
  grid-template-columns: repeat(3,1fr);
  grid-template-rows: 1fr 1fr 1fr;
  gap: 1rem;
}
/* 1. eleman: sol üstten 2 satır kapla */
.sw-grid .sw-item:nth-child(1) {
  grid-column: 1;
  grid-row: 1 / span 2;
}
/* 2. eleman: orta, sadece 1. satır */
.sw-grid .sw-item:nth-child(2) {
  grid-column: 2;
  grid-row: 1;
}
/* 3. eleman: sağ, 2 satır */
.sw-grid .sw-item:nth-child(3) {
  grid-column: 3;
  grid-row: 1 / span 2;
}
/* 4. eleman: sol, 3. satır */
.sw-grid .sw-item:nth-child(4) {
  grid-column: 1;
  grid-row: 3;
}
/* 5. eleman: orta, 2 satır */
.sw-grid .sw-item:nth-child(5) {
  grid-column: 2;
  grid-row: 2 / span 2;
}
/* 6. eleman: sağ, 3. satır */
.sw-grid .sw-item:nth-child(6) {
  grid-column: 3;
  grid-row: 3;
}

.sw-item {
  position: relative;
  overflow: hidden;
  border-radius: var(--rounded);
  cursor: pointer;
}
.sw-item img,
.sw-item video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* video üzeri play ikonu */
.sw-video-thumb {
  position: relative;
}
.sw-play {
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%,-50%);
  width: 48px; height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

/*— POPUP —*/
.sw-popup {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.sw-caption {
  margin: 0;
  font-size: 1rem;
}
</style>
